import TagsEditBlock, { TagsEditBlockProps } from './TagsEditBlock';
import withInteractor from './TagsEditBlock.interactor';
import withPresenter from './TagsEditBlock.presenter';

export type { TagsEditBlockProps };
export default withInteractor(withPresenter(TagsEditBlock));
